import type { StandardApplicability } from '@/shared/hooks/api/machineryDirectiveCompliance'
import type { StandardCardSection } from './StandardCard'
import { StandardCard } from './StandardCard'

type StandardsStandardsListProps = {
  standards: StandardApplicability[]
  section: StandardCardSection
  onDecision: (standardId: string, isAccepted: boolean) => void
  isUpdating?: boolean
  standardDetailSearch?: string
  canRejectById?: Record<string, boolean>
}

export function StandardsStandardsList({
  standards,
  section,
  onDecision,
  isUpdating = false,
  standardDetailSearch,
  canRejectById,
}: StandardsStandardsListProps) {
  return (
    <div className='max-w-full min-w-0 space-y-4'>
      <div className='min-w-0 space-y-2 overflow-y-auto'>
        {standards.map((standard) => (
          <StandardCard
            key={standard.id}
            standard={standard}
            section={section}
            onAccept={() => {
              onDecision(standard.id, true)
            }}
            onReject={() => {
              onDecision(standard.id, false)
            }}
            isUpdating={isUpdating}
            canReject={canRejectById?.[standard.id] ?? true}
            standardDetailSearch={standardDetailSearch}
          />
        ))}
      </div>
    </div>
  )
}
